module.exports = __webpack_public_path__ + "img/metal_k@2x.8f0bf363.png";